import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { withRouter } from "react-router-dom";
import { get } from "lodash";
import Close from "@material-ui/icons/Close";
import Checkbox from "@material-ui/core/Checkbox";
import { Dialog } from "@material-ui/core";

import images from "../../assets/img/images";
import { roles } from "../../constants/roles";
import { fetchGet, fetchPost, fetchPut, fetchPatch } from "../../api/fetch";
import noImageProduct from './assets/no_name_product.svg';
import DropdownDown from './assets/dropdown_arrow_down.svg';
import DropdownRight from './assets/dropdown_arrow_right.svg';
import ManualOrder from "./ManualOrder";
import { roundForJrv } from "../../utils/precision";

const styles = {
  scanProduct: {
    width: "100%",
    maxWidth: "360px",
    height: "640px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    border: "1px solid #dddddd",
    padding: "8px 8px 8px",
    overflow: "hidden",
    '@media(max-width: 470px)': {
      height: "640px",
    }
  },
  scanProductNav: {
    width: "100%",
    backgroundColor: "white",
    display: "grid",
    gridTemplateColumns: "1fr 24px",
    alignItems: "center",
    marginBottom: "12px"
  },
  vmiLocation: {
    fontSize: "16px",
    color: "#5f00a0",
    fontWeight: "500",
    paddingLeft: "4px",
    cursor: "pointer",
  },
  mainTitle: {
    placeSelf: "center",
    fontSize: "14px",
    width: "100%",
    paddingLeft: "4px",
    paddingBottom: "16px",
    borderBottom: "1px solid #dddddd",
    marginBottom: "8px",
    color: "#5f00a0",
    display: "flex",
    alignItems: "center",
  },
  closeButtonContainer: {
    placeSelf: "center",
    width: "24px",
    height: "24px",
    "&:hover": {
      backgroundColor: "#f2f9fa",
      borderRadius: "2px",
      cursor: "pointer",
    }
  },
  closeButton: {
    placeSelf: "center",
  },
  mobileScanMore: {
    marginTop: "4px",
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
  },
  mobileScanMoreCheckbox: {
    width: "18px",
    height: "18px",
    marginRight: "4px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  selectCheckbox: {
    transform: "scale(1.3)",
  },
  scanProductStructure: {
    width: "100%",
    height: "50px",
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
    paddingLeft: "8px",
    boxSizing: "border-box",
  },
  scanProductItem: {
    width: "100%",
    backgroundColor: "white",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    borderBottom: "1px solid #dddddd",
    marginBottom: "8px",
  },
  itemTitle: {
    maxHeight: "45px",
    fontSize: "16px",
    marginBottom: "4px",
    fontWeight: "500",
  },
  itemCodeContainer: {
    display: "flex",
    marginBottom: "4px",
    fontSize: "14px",
  },
  itemCodeSubtitle: {
    fontWeight: "500",
  },
  itemCode: {
    color: "#00000077",
    paddingLeft: "4px",
  },
  headerControl: {
    display: "flex",
    alignItems: "center",
    height: "32px",
    width: "70px",
    cursor: "pointer",
    "& img": {
      paddingRight: "4px",
    }
  },
  itemPicture: {
    maxWidth: "100px",
    maxHeight: "70px",
    marginBottom: "8px",

  },
  itemDetails: {
    fontSize: "14px",
    marginBottom: "8px",
    cursor: "pointer",
  },
  hiddenDetails: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "14px",
    marginBottom: "16px"
  },
  hiddenContainer: {
    display: "flex",
    flexDirection: "column",
    minHeight: "60px",
    height: "100%",
  },
  detailsSubtitle: {
    fontWeight: "500",
  },
  detailsValue: {
    color: "#00000077",
    maxWidth: "160px",
    wordWrap: "break-word",
  },
  orderSubtitle: {
    width: "100%",
    textAlign: "center",
    fontSize: "16px",
  },
  unitsSubtitle: {
    width: "100%",
    textAlign: "left",
    fontSize: "14px",
    marginTop: "8px",
    fontWeight: "500",
    "& span": {
      color: "#00000077",
      fontWeight: "normal",
    }
  },
  scanProductOrder: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    fontSize: "14px",
    flexGrow: "1",
    '@media(max-width: 470px)': {
      minHeight: "initial",
    }
  },
  scanProductBin: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
  },
  orderReplenishment: {
    color: "#eb3c39",
    display: "flex",
    flexDirection: "column",
  },
  sordList: {
    maxHeight: "32px",
    position: "relative"
  },
  sordProductRow: {
    boxSizing: "border-box",
    backgroundColor: "white",
    width: "100%",
    borderRadius: "2px",
    minHeight: "32px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    position: "relative",
    zIndex: "20",
  },
  sordHeaderControl: {
    display: "flex",
    alignItems: "center",
    padding: "4px",
    width: "100%",
  },
  sordHiddenDetails: {
    width: "100%",
    padding: "8px 8px 8px 16px",
    display: "flex",
    flexDirection: "column",
    maxHeight: "250px",
    overflowY: "scroll",
  },
  sordEntry: {
    marginBottom: "8px",
    padding: "2px",
    fontWeight: "500",
    color: "rgba(0,0,0,0.54)",
  },
  sordLink: {
    color: "#5f00a0",
    cursor: "pointer",
    paddingRight: "4px",
  },
  imageContainer: {
    marginRight: "4px",
    width: "20px",
    height: "20px",
    display: "grid",
    placeItems: "center",
    cursor: "pointer",
  },
  textBold: {
    fontWeight: "500"
  },
  orderReplenishmentItems: {
    display: "flex",
    marginTop: "12px",
  },
  ordItem: {
    display: "flex",
    flexDirection: "column",
    marginRight: "32px",
    minWidth: "58px",
  },
  binDetails: {
    fontWeight: "500",
    fontSize: "14px",
    width: "100%",
    marginTop: "8px",
    "& span": {
      color: "#00000077"
    },
    "& span:not(:last-of-type)": {
      marginRight: 40
    }
  },
  deliveryDetails: {
    fontWeight: "500",
  },
  orderOptions: {
    margin: "8px 0 16px 0px",
    fontSize: "14px",
    display: "flex",
    justifyContent: "space-between",
  },
  selectionItem: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  radioButton: {
    transform: "scale(1.5)",
  },
  descriptionItem: {
    marginLeft: "10px",
    fontSize: "14px",
    fontWeight: "500",
  },
  orderFillingContainer: {
    minHeight: "120px",
  },
  orderBinFillingTitle: {
    width: "100%",
    textAlign: "center",
    marginBottom: "4px",
  },
  orderBinFilling: {
    display: "flex",
    justifyContent: "space-between",
  },
  input: {
    width: "92px",
    height: "36px",
    borderRadius: "2px",
    border: "1px solid #00000066",
    textAlign: "center",
    margin: "0 12px",
  },
  clearInput: {
    marginRight: "20px",
  },
  orderFillingButton: {
    fontSize: "20px",
    width: "79px",
    height: "44px",
    border: "1px solid black",
    borderRadius: "3px",
    boxSizing: "border-box",
    backgroundColor: "white",
  },
  orderFillingButtonSelected: {
    border: "1px solid #5f00a0",
    backgroundColor: "#e6edf1",
  },
  orderProductQty: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginBottom: "8px"
  },
  productQty: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "14px",
    fontWeight: "500",
  },
  quantityError: {
    color: "red",
    textAlign: "center",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  inventoryPanel: {
    marginTop: "4px",
    marginBottom: "4px",
    backgroundColor: "#f8f8f8",
    borderRadius: "4px",
    padding: "8px",
  },
  sdelList: {
    maxHeight: "90px",
    overflowY: "auto",
  },
  confirmBtn: {
    width: "112px",
    height: "36px",
    backgroundColor: "#5f00a0",
    borderRadius: "2px",
    border: "none",
    color: "white",
    fontWeight: "500",
    boxShadow: "0px 2px 2px #00000033",
  },
  disabledButton: {
    backgroundColor: "#dddddd",
    color: "#00000061",
    userSelect: "none",
    pointerEvents: "none",
  },
  requestButton: {
    cursor: "not-allowed",
    pointerEvents: "none",
  },
  cancelBtn: {
    width: "112px",
    height: "36px",
    backgroundColor: "white",
    borderRadius: "2px",
    border: "none",
    color: "#5f00a0",
    fontWeight: "500",
    marginRight: "24px"
  },
  manualOrder: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    maxHeight: "calc(100% - 32px)",
  },
  breadcrumbItem: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  breadcrumbItemLast: {
    color: "hsla(0,0%,0%,0.54)"
  },
  breadcrumbIcon: {
    margin: "0 8px",
  },
  blueText: {
    color: "#5f00a0",
    cursor: "pointer",
  },
  warningText: {
    color: "#eb3c39",
  },
  removeDialog: {
    width: "336px",
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    boxSizing: "border-box"
  },

};

const MobileCreateOrderRequest = (props) => {
  const {
    classes,
    language,
    history,
    inventory,
    productData,
    setSelectedProductData,
    setRequests,
    setOpenRequest,
    noReScan,
    setOpenSearch,
    setOpenScan,
    handleBreadcrumbNavigation
  } = props;

  const [vmiId, setVmiId] = React.useState()
  const [productId, setProductId] = React.useState('')
  const [zoneId, setZoneId] = React.useState()
  const [pziId, setPziId] = React.useState()
  const [productName, setProductName] = React.useState("");
  const [zoneUnits, setZoneUnits] = React.useState([]);
  const [zoneBaseUnit, setZoneBaseUnit] = React.useState("");
  const [manufacturer, setManufacturer] = React.useState("");
  const [manufacturerItemCode, setManufacturerItemCode] = React.useState("");
  const [productCategory, setProductCategory] = React.useState("");
  const [productLocation, setProductLocation] = React.useState("");
  const [productLocationBreadcrumbs, setProductLocationBreadcrumbs] = React.useState("");
  const [productLocationBreadcrumbsIds, setProductLocationBreadcrumbsIds] = React.useState("");
  const [showDetails, setShowDetails] = React.useState(false)
  const [totalQuantity, setTotalQuantity] = React.useState(0)
  const [isUpdating, setIsUpdating] = React.useState(false)
  const [orderRequestId, setOrderRequestId] = React.useState('')
  const [minQty, setMinQty] = React.useState(0)
  const [minLvl, setMinLvl] = React.useState("-")
  const [maxQty, setMaxQty] = React.useState(1000)
  const [maxLvl, setMaxLvl] = React.useState("-")
  const [eoq, setEoq] = React.useState(null)
  const [sendingRequest, setSendingRequest] = React.useState(false)
  // ORDER REPLENISHMENT
  const [orderReplenishment, setOrderReplenishment] = React.useState(false)
  const [outstandingQty, setOutstandingQty] = React.useState(0)
  const [receivedQty, setReceivedQty] = React.useState(0)
  const [transitQty, setTransitQty] = React.useState(0)
  const [toPlaceQty, setToPlaceQty] = React.useState(0)
  const [binnedQty, setBinnedQty] = React.useState(0)
  const [isSORDOpen, setIsSORDOpen] = React.useState(false)
  const [sordList, setSordList] = React.useState([])
  const [replenishRequests, setReplenishRequests] = React.useState([])
  // INVENTORY
  const [inventoryValue, setInventoryValue] = React.useState(0)
  const [currentInventoryValue, setCurrentInventoryValue] = React.useState(0)
  const [pziUuid, setPziUuid] = React.useState("")
  const [inventoryDialog, setInventoryDialog] = React.useState(false)
  const [checkedItems, setCheckedItems] = React.useState([])
  // REACTIVATE SCAN
  const [scanMore, setScanMore] = React.useState(true)

  React.useEffect(() => {
    // productData is the information required to fetch the [outstanding order data] and the [order request data]
    const pid = productData?.id ? productData.id : '';
    const zoneId = productData?.zoneId || productData?.zone_id ? productData.zoneId || productData?.zone_id : null;

    setOrderRequestId(productData?.orderRequest?.order_request_id ? productData.orderRequest.order_request_id : '')

    try {
      fetchGet(`order_request/outstanding/${pid}/${zoneId}`)
        .then(res => {
          if (res[0]) {
            // Set [outstanding order data (res)] to state
            if (res[0]) {
              setOrderReplenishment(true)
              setOutstandingQty(res[0].outstanding_quantity || 0)
              setReceivedQty(res[0].quantity || 0) // total quantity (on order)-> quantity
              setTransitQty(res[0].transit_quantitty || 0) // on truck
              setToPlaceQty(res[0].to_be_placed_quantity || 0)
              setBinnedQty(res[0].placed_quantity || 0)
            }
          }
        })
    } catch (e) {
      console.log(e);
    }

    const orderRequestQty = productData?.orderRequest ? productData?.orderRequest.order_request_quantity : 0;
    const orderRequestUnits = productData?.orderRequest ? JSON.parse(productData.orderRequest.order_request_units) : null;

    setProductId(pid)
    setZoneId(zoneId)
    setPziId(productData.pziId)

    try {
      if (orderRequestQty > 0) {
        setIsUpdating(true)
      }

      fetchGet(`product_product_details/${pid}/${zoneId}`)
        .then(product => {
          //product represents the [product and location/zone data]
          console.log(product)

          let productLocation = productData?.orderRequest?.assigned ? productData.orderRequest.assigned.split(" > ") : product.product_assigned.split(" > ")
          setProductLocation(productLocation[0])
          setProductLocationBreadcrumbs(productLocation.slice(1).join(" > "))
          setProductLocationBreadcrumbsIds(product.product_assigned_ids.split(" > ").map(b => parseInt(b)))
          setVmiId(product.product_assigned_ids.split(" > ").map(b => parseInt(b))[0])

          let productName = language === 'en' ? product.product_details.filter(d => d.attribute_id === 214)[0].attribute_value : product.product_details.filter(d => d.attribute_id === 213)[0].attribute_value // 213 FR - 214 EN
          setProductName(productName)
          setProductCategory(product.product_details.filter(d => d.attribute_id === 235)[0].attribute_value)
          setManufacturer(product.product_details.filter(d => d.attribute_id === 243)[0].attribute_value)
          setManufacturerItemCode(product.product_details.filter(d => d.attribute_id === 244)[0].attribute_value)

          const baseUnitAttribute = product.product_zone_details.find(d => d.sys_attribute_id === 216);
          const baseUnitCode = baseUnitAttribute.attribute_value;
          setZoneBaseUnit(baseUnitCode);

          let productU = JSON.parse(product.product_zone_details.filter(d => d.sys_attribute_id === 231)[0].attribute_value).units;
          let tmpProductU;
          if (orderRequestQty > 0) {
            tmpProductU = orderRequestUnits;
          } else {
            tmpProductU = productU.map(d => {
              return { ...d, amountToOrder: 0 }
            })
          }
          const sortProductU = [...tmpProductU].sort((a, b) => a.quantity - b.quantity);
          setZoneUnits(sortProductU);
          setMinQty(product.product_zone_details?.filter(d => d.sys_attribute_id === 224)[0]?.attribute_value)
          setMinLvl(product.product_zone_details?.filter(d => d.sys_attribute_id === 238)[0]?.picklist.name_en)
          setMaxQty(product.product_zone_details?.filter(d => d.sys_attribute_id === 223)[0]?.attribute_value)
          setMaxLvl(product.product_zone_details?.filter(d => d.sys_attribute_id === 239)[0]?.picklist.name_en)
          setEoq(product.economic_order_quantity)
          setInventoryValue(product.product_zone_inventory_quantity ? product.product_zone_inventory_quantity : 0)
          setCurrentInventoryValue(product.product_zone_inventory_quantity ? product.product_zone_inventory_quantity : 0)
          setPziUuid(product.product_zone_inventory_id)
          setSelectedProductData({})
          setSordList(product.product_commandes)
        })
        .catch(e => console.error(e));
      fetchGet(`replenish_request/outstanding_by_zone/${pid}/${zoneId}`)
        .then(repRequests => {
          setReplenishRequests(repRequests.map(r => { return { ...r, checked: false } }))
        })
        .catch(e => console.error(e));
    } catch (e) {
      console.log(e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const createOrderRequest = () => {
    // console.log(checkedItems)
    setSendingRequest(true);
    const body = {
      "active": true,
      "zone_id": zoneId,
      "product_id": productId,
      "quantity": totalQuantity,
      "product_zone_inventory_id": pziUuid,
      "description": `Order Request of ${totalQuantity} ${productName}`,
      "unit_of_measurement": JSON.stringify(zoneUnits.map(p => ({ amountToOrder: p.amountToOrder, bc_code: p.bc_code, quantity: p.quantity }))),
      "quantity_delivered": 0,
      "sys_order_req_status_id": "2b1327a7-4a26-4931-a41b-2794e2b3d7de",
      "attributes": [
        {
          'id': 216,
          'value': zoneBaseUnit
        }
      ]
    }

    try {
      fetchPost("order_request", body)
        .then(res => {
          setSendingRequest(false);
          fetchGet(`order_request_product_details/${vmiId}`)
            .then(orderReq => {
              if (setRequests) setRequests(orderReq.data.map(orderReq => { return { ...orderReq, checked: false } }))
              setOpenRequest(false)
              if (setOpenSearch) setOpenSearch(false)
              if (scanMore) setOpenScan(true)
              history.push(`/wms/requests/${vmiId}`)
            })
        })
        .catch(e => console.error(e))
    } catch (e) {
      console.log(e);
    }
  }

  const updateOrderRequest = () => {
    setSendingRequest(true);
    const body = {
      "id": orderRequestId,
      "quantity": totalQuantity,
      "unit_of_measurement": JSON.stringify(zoneUnits.map(p => ({ amountToOrder: p.amountToOrder, bc_code: p.bc_code, quantity: p.quantity }))),
    }

    try {
      fetchPut("order_request", body)
        .then(res => {
          setSendingRequest(false);
          fetchGet(`order_request_product_details/${vmiId}`)
            .then(orderReq => {
              if (setRequests) setRequests(orderReq.data.map(orderReq => { return { ...orderReq, checked: false } }))
              setOpenRequest(false)
              history.push(`/wms/requests/${vmiId}`)
              if (scanMore) setOpenScan(true)
            })
        })
        .catch(e => console.error(e))
    } catch (e) {
      console.log(e);
    }
  }

  const generateManualOrders = () => {
    return zoneUnits.map((p, i) =>
      <ManualOrder
        key={`key-${i}`}
        base_bc_code={zoneBaseUnit}
        bc_code={p.bc_code}
        quantity={roundForJrv(p.quantity, zoneBaseUnit)}
        amountToOrder={p.amountToOrder}
        setProductUnits={setZoneUnits}
        productUnits={zoneUnits}
        setTotalQuantity={setTotalQuantity}
      />
    )
  }

  const generateBreadcrumbs = () => {
    return productLocationBreadcrumbs.split(" > ").map((item, i) => {
      if (i < (productLocationBreadcrumbs.split(" > ").length - 1)) {
        return <span className={classes.breadcrumbItem} key={`bc-item-${i}`}>
          <span onClick={() => handleBreadcrumbNavigation(productLocationBreadcrumbsIds.slice(1)[i])}>{item}</span>
          <img src={images.breadcrumbIconBlack} height="12px" alt=">" className={classes.breadcrumbIcon} />
        </span>
      } else {
        return <span className={classes.breadcrumbItemLast} key={`bc-item-${i}`}>{item} ({pziId})</span>
      }
    })

  }

  const handleSetValue = input => {
    const val = input.target.value;
    if (val === "") {
      setInventoryValue("")
    } else if (val !== "-" && val !== null && val !== undefined && !isNaN(parseInt(val))) {
      setInventoryValue(parseInt(val))
    }
  }

  const handleFocus = (e) => {
    e.target.select()
  }

  const handleBlur = (e) => {
    const val = e.target.value;
    if (val === "") {
      setInventoryValue(0)
    }
  }

  const handleInventoryUpdate = () => {
    const body = {
      "quantity": inventoryValue,
      "replenish_requests": checkedItems[0] ? checkedItems.map(r => r.id) : [], // [] or null
    }
    try {
      fetchPatch(
        `/product_zone_inventory/${pziUuid}`, body
      ).then(res => {
        setInventoryDialog(true)
        setTimeout(() => {
          setInventoryDialog(false)
          setOpenRequest(false)
          if (scanMore) setOpenScan(true)
        }, 3000)
      })
    } catch (e) {
      console.log(e);
    }
  }

  const handleCheckItem = (e, deliveryRequest) => {
    if (e.target.checked) {
      setInventoryValue([...checkedItems, deliveryRequest].reduce((pV, cV) => pV + parseInt(cV.attributes?.filter(d => d.sys_attribute_id === 267)[0]?.attribute_value), 0))
      setCheckedItems(checkedItems => [...checkedItems, deliveryRequest])
      setReplenishRequests(replenishRequests.map(r => {
        if (deliveryRequest.id === r.id) {
          return {
            ...r,
            checked: true
          }
        } else {
          return r
        }
      }))
    } else {
      setCheckedItems(checkedItems.filter(p => p.id !== deliveryRequest.id))
      setInventoryValue(checkedItems.filter(p => p.id !== deliveryRequest.id).reduce((pV, cV) => pV + parseInt(cV.attributes?.filter(d => d.sys_attribute_id === 267)[0]?.attribute_value), 0))
      setReplenishRequests(replenishRequests.map(r => {
        if (deliveryRequest.id === r.id) {
          return {
            ...r,
            checked: false
          }
        } else {
          return r
        }
      }))
    }
  }

  const level = get(props, ["userRole", "level"]);

  return (
    (<div className={classes.scanProduct}>
      <div className={classes.scanProductNav}>
        <div className={classes.vmiLocation} onClick={() => handleBreadcrumbNavigation(productLocationBreadcrumbsIds[0])}>{productLocation}</div>
        <div className={classes.closeButtonContainer}>
          <Close className={classes.closeButton}
            onClick={() => setOpenRequest(false)} />
        </div>
      </div>
      <div className={classes.mainTitle}>
        {generateBreadcrumbs()}
      </div>
      <div className={classes.scanProductItem}>
        <div className={classes.itemTitle}>{productName}</div>
        <div className={classes.itemCodeContainer}>
          <div className={classes.itemCodeSubtitle}>{language === 'en' ? `${I18n.get("manufacturer_item_code")}:` : `${I18n.get("manufacturer_item_code")} :`}</div>
          <div className={classes.itemCode}>{manufacturerItemCode}</div>
        </div>
        <div className={classes.headerControl} onClick={() => setShowDetails(!showDetails)}>
          <img src={showDetails ? DropdownDown : DropdownRight} alt="Dropdown" />
          <div>{I18n.get("site_details")}</div>
        </div>
        {showDetails ?
          <>
            <div className={classes.itemPicture}>
              <img
                src={noImageProduct}
                alt="Product"
                className={classes.noImageProduct}
              />
            </div>
            <div className={classes.hiddenDetails}>
              <div className={classes.hiddenContainer}>
                <div className={classes.detailsSubtitle}>{I18n.get("manufacturer")}</div>
                <div className={classes.detailsValue}>{manufacturer}</div>
              </div>
              <div className={classes.hiddenContainer}>
                <div className={classes.detailsSubtitle}>{I18n.get("category")}</div>
                <div className={classes.detailsValue} title={productCategory}>
                  {productCategory}
                </div>
              </div>
            </div>
          </>
          : null}
      </div>
      <div className={classes.scanProductOrder}>
        <div className={classes.orderSubtitle}>{!inventory ? I18n.get("order_noun_jrv") : I18n.get("inventory")}</div>
        <div className={classes.scanProductBin}>
          {orderReplenishment ?
            <div className={classes.orderReplenishment}>
              <div className={classes.sordList}>
                <div className={classes.sordProductRow} >
                  <div className={classes.mobileRowHeader}>
                    <div className={classes.sordHeaderControl}>
                      <div className={classes.imageContainer} onClick={() => setIsSORDOpen(!isSORDOpen)} >
                        <img src={isSORDOpen ? DropdownDown : DropdownRight} alt="Dropdown" />
                      </div>
                      <div>
                        <div className={classes.textBold}>{`(${sordList.length}) SORD`}</div>
                      </div>
                    </div>
                  </div>
                  {isSORDOpen ?
                    <div className={classes.sordHiddenDetails}>
                      {sordList.map(s =>
                        <div className={classes.sordEntry}>
                          <a href={s.url} rel="noopener" target="_blank"><span className={classes.sordLink}>{s.order_customer_order_id}</span></a> {s.order_req_created_on.split(".")[0]}
                        </div>)
                      }
                    </div>
                    : null
                  }
                </div>
              </div>
              <div className={classes.orderReplenishmentItems}>
                <div className={classes.ordItem}>
                  <div className={classes.itemCodeSubtitle}>{I18n.get("replenishment_outstanding")}</div>
                  <div>{roundForJrv(outstandingQty, zoneBaseUnit)}</div>
                </div>
                <div className={classes.ordItem}>
                  <div className={classes.itemCodeSubtitle}>{I18n.get("replenishment_en_route")}</div>
                  <div>{roundForJrv(transitQty, zoneBaseUnit)}</div>
                </div>
                <div className={classes.ordItem}>
                  <div className={classes.itemCodeSubtitle}>{I18n.get("replenishment_delivered")}</div>
                  <div>{roundForJrv(toPlaceQty, zoneBaseUnit)}</div>
                </div>
              </div>
            </div> : null
          }
          <div className={classes.binDetails}>
            Min{language === "en" ? ":" : " :"} <span>{minQty} {minLvl ? `(${minLvl})` : "-"}</span>
            Max{language === "en" ? ":" : " :"} <span>{maxQty} {maxLvl ? `(${maxLvl})` : "-"}</span>
            EOQ{language === "en" ? ":" : " :"} <span>{eoq != null ? eoq : "-"}</span>
          </div>
          <div className={classes.unitsSubtitle}>{I18n.get("unit_of_measure")}{language === "en" ? ":" : " :"}&nbsp;
            <span>{zoneBaseUnit}</span>
          </div>
          {!inventory ? null : <div className={classes.unitsSubtitle}>{`${I18n.get("current_inventory")}`}{language === "en" ? ":" : " :"}&nbsp;
            <span>{currentInventoryValue}</span>
          </div>}
        </div>
        <div className={classes.orderFillingContainer}>
          {!inventory ?
            <div className={classes.orderBoxFilling}>
              {generateManualOrders()}
            </div>
            :
            <>
              <div className={classes.inventoryPanel}>
                <div className={classes.orderSubtitle}>{`${I18n.get("replenishment_to_bin")} (${transitQty + toPlaceQty})`}</div>
                <div className={classes.sdelList}>
                  {replenishRequests.map((r, i) =>
                    <div style={{ display: "flex", alignItems: "center" }} key={r.id}>
                      <Checkbox
                        color="primary"
                        checked={r.checked}
                        onChange={e => handleCheckItem(e, r)}
                        value={r.checked}
                      />
                      <div style={{ fontWeight: "500" }}>{parseInt(r.attributes?.filter(d => d.sys_attribute_id === 267)[0]?.attribute_value)}</div>
                      <div style={{ marginLeft: "4px", color: "rgba(0, 0, 0, 0.54)" }}>({r.customer_delivery_id})</div>
                    </div>)
                  }
                </div>
              </div>
              <span className={classes.detailsSubtitle}>{I18n.get("inventory")}{language === "en" ? ":" : " :"}</span>
              <input
                className={classes.input}
                inputMode="numeric"
                value={inventoryValue}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onChange={e => handleSetValue(e)} La valeur
              >
              </input>
              {inventoryValue > maxQty ? <div className={classes.warningText}>{I18n.get("order_request_max_warning")}</div> : null}
            </>
          }
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        {!inventory ?
          <div className={classes.orderProductQty}>
            {maxQty && totalQuantity > maxQty ? <div className={classes.quantityError}>{I18n.get("order_request_max_warning")}</div> : null}
            <div className={classes.productQty}>
              {I18n.get("total_quantity")}: {roundForJrv(totalQuantity, zoneBaseUnit)}
            </div>
          </div>
          : null
        }
        <div className={classes.buttonContainer}>
          <Dialog open={inventoryDialog} PaperProps={{ style: { margin: "0" }, }} onBackdropClick={() => setInventoryDialog(false)}>
            <div className={classes.removeDialog}>
              <div>{checkedItems[0] ? I18n.get("inventory_placed_with_sdel") : I18n.get("inventory_placed")}</div>
            </div>
          </Dialog>
          <button
            className={classes.cancelBtn}
            type="button"
            onClick={() => setOpenRequest(false)}>{I18n.get("site_cancel").toUpperCase()}</button>
          {
            level <= roles.requester ?
              !inventory ?
                !isUpdating ?
                  <button
                    className={`${classes.confirmBtn} ${totalQuantity === 0 ? classes.disabledButton : ""} ${sendingRequest ? classes.requestButton : ""}`}
                    type="button"
                    onClick={() => createOrderRequest()}>{I18n.get("site_confirm").toUpperCase()}</button>
                  :
                  <button
                    className={`${classes.confirmBtn} ${totalQuantity === 0 ? classes.disabledButton : ""} ${sendingRequest ? classes.requestButton : ""}`}
                    type="button"
                    onClick={() => updateOrderRequest()}>{I18n.get("site_confirm").toUpperCase()}</button>
                :
                <button
                  className={`${classes.confirmBtn} ${false ? classes.disabledButton : ""} ${sendingRequest ? classes.requestButton : ""}`}
                  type="button"
                  onClick={() => handleInventoryUpdate()}>{I18n.get("site_confirm").toUpperCase()}</button>
              : null
          }
        </div>
      </div>
      {!noReScan ?
        <div className={classes.mobileScanMore} onClick={e => setScanMore(!scanMore)}>
          <div className={classes.mobileScanMoreCheckbox}>
            <Checkbox
              color="primary"
              checked={scanMore}
              onChange={e => setScanMore(!scanMore)}
            />
          </div>
          <div className={classes.mobileScanMoreText}>{I18n.get("scan_more")}</div>
        </div> : null}
    </div>)
  );
};

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
    companies: get(state, ["companies"]),
    user: state.user,
    userRole: get(state, ["user", "role"]),
    solutionsAccess: get(state, ["user", "solutionsAccess"]),
    permissions: get(state, ["user", "permissions"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(MobileCreateOrderRequest, ManualOrder))
);
